import React, { useRef, useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import ThumbnailCard from "../../../../components/card/ThumbnailCard";
import { useSelector, useDispatch } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import Crab from "../../../../Asset/icon/Crab.svg";
import BinocularsRight from "../../../../Asset/icon/binoculars-right.svg";
import BinocularsLeft from "../../../../Asset/icon/Binoculars-left.svg";
import CustomButtonGroupAsArrows from "../../../../components/carousel/CustomButtonGroupAsArrows";
import { Link } from "react-router-dom";
import { getYachtDetail } from "../../../../redux/yacht/YachtSlice";
import { getPromotionDetail } from "../../../../redux/promotion/PromotionSlice";
import { getYachtInformationDetail } from "../../../../redux/yachtInformation/YachtInformationSlice";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import "../../../../Asset/scss/Homepages/Hotdeals.scss";
import {
  getProvinceDetail,
  getCountryDetail,
  getMarinaDetail,
  getNationalityDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function Hotdeal({ promoFilter, onClear }) {
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  const carouselRef1 = useRef(null);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 2999, min: 1440 },
      items: 3,
    },
    laptop: {
      breakpoint: { max: 1439, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1023, min: 720 },
      items: 1, // 🔽 จาก 3 → 2
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 719, min: 0 },
      items: 1, // 🔽 จาก 2 → 1
      partialVisibilityGutter: 40,
    },
  };

  const CustomDot = ({ onClick, index, active }) => (
    <button
      style={{
        background: active ? "#00305c" : "grey",
        width: "5px",
        height: "5px",
        margin: "auto",
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
      }}
      onClick={() => onClick()}
    ></button>
  );

  const [loading, setLoading] = useState(true);
  const [selectedProvince, setSelectedProvince] = useState("Phuket");
  const alertedRef = useRef(false);
  const usedPromoRef = useRef(new Set());
  const lockedPromoIdRef = useRef(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "warning",
  });

  const showSnackbar = (message, severity = "warning") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  const calculateDiscountedPrice = (
    originalPrice,
    discountValue,
    discountType,
  ) => {
    const parsedOriginalPrice = parseFloat(originalPrice);
    const parsedDiscountValue = parseFloat(discountValue);

    if (isNaN(parsedOriginalPrice) || isNaN(parsedDiscountValue)) {
      return "Invalid Price or Discount";
    }

    let discountedPrice;

    if (discountType === "Percent") {
      const discountedAmount =
        (parsedOriginalPrice * parsedDiscountValue) / 100;
      discountedPrice = parsedOriginalPrice - discountedAmount;
    } else {
      discountedPrice = parsedOriginalPrice - parsedDiscountValue;
    }

    return discountedPrice <= 0 ? "FREE" : discountedPrice.toFixed(2);
  };

  useEffect(() => {
    Promise.all([
      dispatch(getProvinceDetail({})),
      dispatch(getCountryDetail({})),
      dispatch(getMarinaDetail({})),
      dispatch(getYachtDetail({})),
      dispatch(getYachtInformationDetail({})),
      dispatch(getPromotionDetail({})),
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
      dispatch(getNationalityDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    // โหลดครั้งแรก
    dispatch(getPromotionDetail({}));

    const interval = setInterval(() => {
      dispatch(getPromotionDetail({}));
    }, 5000);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    // โหลดครั้งแรก
    dispatch(getYachtInformationDetail({}));

    const interval = setInterval(() => {
      dispatch(getYachtInformationDetail({}));
    }, 5000);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    if (!promoFilter) return;

    // ตัวอย่าง
    if (promoFilter.type === "code") {
      // filter ด้วย promo code
    }
  }, [promoFilter]);

  useEffect(() => {
    if (!promoFilter?.data?.id_promotion) {
      lockedPromoIdRef.current = null;
      usedPromoRef.current.clear();
      alertedRef.current = false;
    }
  }, [promoFilter?.data?.id_promotion]);

  useEffect(() => {
    // reset ทุกครั้งที่ user ใส่ promo ใหม่
    usedPromoRef.current.clear();
    alertedRef.current = false;
    lockedPromoIdRef.current = promoFilter?.data?.id_promotion ?? null;
  }, [promoFilter?.data?.id_promotion, promoFilter?.type, promoFilter?.value]);

  let globalIndexCounter = 0;

  if (loading) {
    return (
      <div>
        <CircularProgress className="text-primary-dark" />
      </div>
    );
  }

  // ----------------------------
  // PROMO FILTER SETUP
  // ----------------------------
  const selectedPromoId =
    promoFilter?.data?.id_promotion != null
      ? Number(promoFilter.data.id_promotion)
      : null;

  // ----------------------------
  // MAIN LOGIC
  // ----------------------------
  const filteredAndIndexedPromotions =
    todos?.YachtInfoSellingPriceRatePlanListSlice?.YachtInfoSellingPriceRatePlanList?.results
      ?.filter((item) => item.rate_plan_use_in_TMY_web_site === 1)
      .map((filteredItem) => {
        // ----------------------------
        // BASE PROMOTIONS FROM DB
        // ----------------------------

        const dbPromotions =
          todos?.PromotionSlice?.Promotion?.results?.filter((promotionItem) => {
            const customizeYachtList = promotionItem.customize_yacht
              ?.split(",")
              .map((id) => id.trim());

            const isSameCompany =
              Number(promotionItem.id_yacht) === Number(filteredItem.id_yacht);

            // is_all_time = 1 และไม่มีวันหมดอายุ → ใช้ได้ตลอดไป
            const isAllTime =
              Number(promotionItem.is_all_time) === 1 && !promotionItem.end_date_valid;

            const isNotExpired =
              isAllTime ||
              !promotionItem.end_date_valid ||
              new Date(promotionItem.end_date_valid) > new Date();

            const isCustomizeMatch = selectedPromoId
              ? !promotionItem.customize_yacht ||
              customizeYachtList?.includes(String(filteredItem.id_yachtInfo))
              : customizeYachtList?.includes(String(filteredItem.id_yachtInfo));

            return isSameCompany && isNotExpired && isCustomizeMatch;
          }) || [];

        // ----------------------------
        // MERGE MANUAL PROMO
        // ----------------------------
        const basePromotions = [
          ...dbPromotions,
          // ...(manualPromotion ? [manualPromotion] : []),
        ]
          .filter((promotionItem) => {
            // ไม่มี promoFilter → เอาหมด
            if (!selectedPromoId) return true;

            // promo ที่ user เลือก → เอา
            if (Number(promotionItem.id_promotion) === selectedPromoId) {
              return true;
            }

            // promo เฉพาะลำ (มี customize_yacht) → เอาได้
            if (promotionItem.customize_yacht) {
              return true;
            }

            // promo public อื่น ๆ → ตัดทิ้ง
            return false;
          })
          .map((promotionItem) => ({
            ...promotionItem,

            apply_id_yacht: promotionItem.id_yacht,

            value_sellingPrice: filteredItem.value_sellingPrice,
            id_yachtInfo: filteredItem.id_yachtInfo,
            id_sellingPrice: filteredItem.id_sellingPrice,
            uniqueIndex: globalIndexCounter++,
          }));

        // ----------------------------
        // NO PROMO FILTER
        // ----------------------------
        if (!selectedPromoId) {
          return basePromotions;
        }

        // ----------------------------
        // PROMO FROM DB (CODE)
        // ----------------------------
        if (selectedPromoId) {
          const matchedPromo = basePromotions.find(
            (p) => Number(p.id_promotion) === selectedPromoId,
          );

          if (!matchedPromo) {
            if (!alertedRef.current) {
              showSnackbar(t("promo_not_applicable_for_yacht"));
              alertedRef.current = true;

              onClear?.();
              localStorage.removeItem("promoFilter");
            }
            return basePromotions;
          }

          // ✅ ค่อยเช็ค apply_promotion
          if (matchedPromo.apply_promotion !== "Accept") {
            if (!alertedRef.current) {
              showSnackbar(t("promo_not_supported_on_web"));
              alertedRef.current = true;

              onClear?.();
              localStorage.removeItem("promoFilter");
            }
            return basePromotions;
          }

          // const isPromoLimitReached =
          //   Number(matchedPromo.use_promotion) ===
          //   Number(matchedPromo.promotion_limit_time);

          // if (isPromoLimitReached) {
          //   if (!alertedRef.current) {
          //     showSnackbar(t("promo_limit_reached"));
          //     alertedRef.current = true;

          //     onClear?.();
          //     localStorage.removeItem("promoFilter");
          //   }
          //   return basePromotions;
          // }

          const isPromoValidForDay = (promotion, bookingDate = new Date()) => {
            const day = bookingDate.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat

            const dayMap = {
              0: promotion.sun_valid_customize_day,
              1: promotion.mon_valid_customize_day,
              2: promotion.tue_valid_customize_day,
              3: promotion.wed_valid_customize_day,
              4: promotion.thu_valid_customize_day,
              5: promotion.fri_valid_customize_day,
              6: promotion.sat_valid_customize_day,
            };

            const allDays = [
              promotion.mon_valid_customize_day,
              promotion.tue_valid_customize_day,
              promotion.wed_valid_customize_day,
              promotion.thu_valid_customize_day,
              promotion.fri_valid_customize_day,
              promotion.sat_valid_customize_day,
              promotion.sun_valid_customize_day,
            ].map(Number);

            const isAllZero = allDays.every((d) => d === 0);

            // ✔ ใช้ได้ทุกวัน
            if (isAllZero) return true;

            // ✔ ใช้ได้เฉพาะวันที่เป็น 1
            return Number(dayMap[day]) === 1;
          };

          // ❌ เช็ควันใช้งาน promo  ⭐️ เพิ่มตรงนี้
          const bookingDate = new Date();
          // 👉 แนะนำ: ใช้วันที่จริง
          // const bookingDate = new Date(filteredItem.activity_date);

          const isValidDay = isPromoValidForDay(matchedPromo, bookingDate);

          if (!isValidDay) {
            if (!alertedRef.current) {
              showSnackbar(t("promo_invalid_day"));
              alertedRef.current = true;

              onClear?.();
              localStorage.removeItem("promoFilter");
            }
            return basePromotions;
          }

          const isCustomizePromo = Boolean(matchedPromo?.customize_yacht);

          const shouldBlockPromo =
            selectedPromoId &&
            isCustomizePromo && // ✅ block เฉพาะ promo ที่มี customize_yacht
            usedPromoRef.current.has(selectedPromoId);

          // const shouldBlockPromo =
          //   selectedPromoId && usedPromoRef.current.has(selectedPromoId);

          if (shouldBlockPromo) {
            if (!alertedRef.current) {
              showSnackbar(t("promo_already_used"));
              alertedRef.current = true;

              onClear?.();
              localStorage.removeItem("promoFilter");
            }
            return basePromotions;
          }

          // mark used (ครั้งเดียว)
          if (isCustomizePromo) {
            usedPromoRef.current.add(selectedPromoId);
          }
          return basePromotions;
        }

        console.groupEnd();

        // ----------------------------
        // MANUAL DISCOUNT (ALWAYS OK)
        // ----------------------------
        return basePromotions;
      })
      .flat();

  if (!filteredAndIndexedPromotions) {
    console.error("Data not available");
    return <div>Data not available</div>;
  }

  const filteredPromotionsByProvince = filteredAndIndexedPromotions.filter(
    (promotion) => {
      if (
        promotion.apply_promotion !== "Accept" ||
        promotion.promotion_status !== "Public"
      ) {
        return false;
      }

      // if (
      //   promotion.promotion_limit_time !== 0 && // กรณี 0 = No Limit (ถ้ามี)
      //   promotion.use_promotion >= promotion.promotion_limit_time
      // ) {
      //   return false;
      // }

      const dayKeys = [
        "sun_valid_customize_day",
        "mon_valid_customize_day",
        "tue_valid_customize_day",
        "wed_valid_customize_day",
        "thu_valid_customize_day",
        "fri_valid_customize_day",
        "sat_valid_customize_day",
      ];

      const isAllZero = dayKeys.every((key) => promotion[key] === 0);

      if (!isAllZero) {
        const today = new Date().getDay(); // 0-6
        const todayKey = dayKeys[today];

        if (promotion[todayKey] !== 1) {
          return false;
        }
      }

      const matchingYachtInformation =
        todos.YachtInformationSlice?.YachtInformation?.results?.find(
          (yachtItem) => yachtItem.id_yachtInfo === promotion.id_yachtInfo,
        );

      const matchingMarina = todos.CenterDataSlice?.Marina?.results?.find(
        (MarinaItem) =>
          MarinaItem.id_marina === matchingYachtInformation?.id_marina,
      );

      const matchingProvince = todos.CenterDataSlice?.Province?.results?.find(
        (provinceItem) =>
          provinceItem.ProvinceID === matchingMarina?.id_province,
      );
      return (
        !selectedProvince ||
        (matchingProvince && matchingProvince.ProvinceEng === selectedProvince)
      );
    },
  );

  const formatDateOnly = (date) => {
    if (!date) return "";

    const d = new Date(date);

    if (isNaN(d.getTime())) return date;

    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
  };

  const getValidDateText = (promotion) => {
    const isAllTime =
      Number(promotion.is_all_time) === 1 && !promotion.end_date_valid;

    if (isAllTime) return t("promo_all_time", "No Expiry");

    return `${formatDateOnly(promotion.start_date_valid)} - ${formatDateOnly(
      promotion.end_date_valid,
    )}`;
  };

  return (
    <div className="bodyTop-container">
      <div
        className="Header-Frame flex-wrap-col-space"
      >
        <div>
          <img
            draggable={false}
            className="BoatHelm-Tophotdeal cursor-pointer"
            src={BoatHelm}
            alt="BoatHelm"
          />
        </div>

        <div className="hotdeal-ofday">
          <h2>
            <img className="BoatHelm-hotdeal" src={Crab} alt="BoatHelm" />
          </h2>
          <h2
            className="cursor-pointer"
            onClick={() => setSelectedProvince("")}
          >
            {t("hotDeal")}
          </h2>
          <h2>
            <img
              className="BoatHelm-hotdeal"
              draggable={false}
              src={Crab}
              alt="BoatHelm"
            />
          </h2>
        </div>

        <div className="hotdeal-ofday">
          <h2>
            <img
              draggable={false}
              className="BoatHelm-hotdeal"
              src={BinocularsRight}
              alt="BoatHelm"
            />
          </h2>

          <h2 className="cursor-pointer">
            {todos?.CenterDataSlice?.Marina?.results?.length > 0 ? (
              Array.from(
                new Set(
                  todos.CenterDataSlice.Marina.results.map((filteredItem) => {
                    const matchingProvince =
                      todos.CenterDataSlice.Province.results?.find(
                        (provinceItem) =>
                          provinceItem.ProvinceID === filteredItem.id_province,
                      );

                    const provinceName = matchingProvince
                      ? selectedLanguage === "th"
                        ? matchingProvince.ProvinceThai
                        : matchingProvince.ProvinceEng
                      : null;

                    return JSON.stringify({
                      name: provinceName,
                      engName: matchingProvince?.ProvinceEng,
                    });
                  }),
                ),
              )
                .slice(0, 5)
                .map((provinceStr, index, array) => {
                  const { name, engName } = JSON.parse(provinceStr);
                  return (
                    <div
                      key={index}
                      className={selectedProvince === engName ? "selected" : ""}
                      onClick={() => setSelectedProvince(engName)}
                    >
                      <span className="province-hot"> {name} </span>
                      {index < array.length - 1}
                    </div>
                  );
                })
            ) : (
              <div>
                <CircularProgress className="text-primary-dark" />
              </div>
            )}
          </h2>

          <h2>
            <img
              draggable={false}
              className="BoatHelm-hotdeal"
              src={BinocularsLeft}
              alt="BoatHelm"
            />
          </h2>
        </div>
      </div>

      <div className="relative-full">
        <div className="carousel-container">
          {filteredPromotionsByProvince.length > 0 ? (
            <Carousel
              ref={carouselRef1}
              centerMode={true}
              customButtonGroup={
                window.innerWidth >= 719 ? (
                  <CustomButtonGroupAsArrows
                    carouselRefs={[carouselRef1]}
                    customPreviousStyle={{ left: "-10vh", zIndex: "999" }}
                    customNextStyle={{ right: "-10vh", zIndex: "999" }}
                  />
                ) : null
              }
              renderButtonGroupOutside
              additionalTransfrom={0}
              arrows={false}
              className=""
              containerClass="container"
              dotListClass=""
              draggable
              focusOnSelect={false}
              infinite
              itemClass=""
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderDotsOutside={false}
              responsive={responsive}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots={false}
              customDot={<CustomDot />}
              sliderClass=""
              slidesToSlide={1}
              swipeable
              autoPlay={true}
              autoPlaySpeed={4000}
            >
              {filteredAndIndexedPromotions.map((promotion, index) => {
                const matchingYachtInformation =
                  todos.YachtInformationSlice.YachtInformation.results.find(
                    (yachtItem) =>
                      yachtItem.id_yachtInfo === promotion.id_yachtInfo,
                  );

                const yachtDetail = todos.YachtSlice.Yacht.results.find(
                  (YachtDetailItem) =>
                    YachtDetailItem.id_yacht === promotion.apply_id_yacht,
                );

                const matchingMarina =
                  todos.CenterDataSlice.Marina.results.find(
                    (MarinaItem) =>
                      MarinaItem.id_marina ===
                      matchingYachtInformation.id_marina,
                  );

                const matchingProvince =
                  todos.CenterDataSlice.Province.results.find(
                    (provinceItem) =>
                      provinceItem.ProvinceID === matchingMarina.id_province,
                  );

                // ตรงนี้ใช้ promotion.id_sellingPrice แทน
                const matchingYachtInformationWithPrice = {
                  ...matchingYachtInformation,
                  id_sellingPrice: promotion.id_sellingPrice, // ✅ ใช้ตรงนี้
                };

                if (
                  !matchingYachtInformationWithPrice ||
                  Number(matchingYachtInformationWithPrice.status_yachtInfo) !==
                  1
                ) {
                  return null;
                }

                if (
                  !selectedProvince ||
                  (matchingProvince &&
                    matchingProvince.ProvinceEng === selectedProvince)
                ) {
                  return (
                    <div key={index} className="row">
                      <div>
                        <Link
                          // to={`/yacht/detailYacht/${matchingYachtInformationWithPrice.id_sellingPrice}`}

                          to={`/yacht/detailYacht/${matchingYachtInformationWithPrice.id_sellingPrice
                            }?price=${calculateDiscountedPrice(
                              promotion.value_sellingPrice,
                              promotion.discount_value_promotion,
                              promotion.discount_promotion,
                            )}&originalPrice=${promotion.value_sellingPrice
                            }&discountType=${promotion.discount_promotion
                            }&discountValue=${promotion.discount_value_promotion}
                          &promotionCode=${promotion.promotion_code}`}
                        >
                          <ThumbnailCard
                            image={matchingMarina.marina_img}
                            headline={
                              matchingYachtInformationWithPrice.name_yacht_yachtInfo
                            }
                            location={
                              selectedLanguage === "th"
                                ? matchingMarina.name_marina_th
                                : matchingMarina.name_marina_en
                            }
                            province={
                              selectedLanguage === "th"
                                ? matchingProvince.ProvinceThai
                                : matchingProvince.ProvinceEng
                            }
                            vaildDate={getValidDateText(promotion)}
                            price={calculateDiscountedPrice(
                              promotion.value_sellingPrice,
                              promotion.discount_value_promotion,
                              promotion.discount_promotion,
                            )}
                            originalPrice={promotion.value_sellingPrice}
                            currency={yachtDetail.currency}
                            discount_promotion={
                              promotion.discount_promotion === "Percent"
                                ? "%"
                                : promotion.discount_promotion
                            }
                            discount_value_promotion={
                              promotion.discount_value_promotion
                            }
                          />
                        </Link>
                      </div>
                    </div>
                  );
                }
              })}
            </Carousel>
          ) : (
            <div
              className="flex-center-minh"
            >
              <div
                className="upload-card"
              >
                {/* Icon */}
                <div className="text-3rem">⚓</div>

                {/* Title */}
                <div
                  className="text-xl-semibold"
                >
                  {t("No Hot Deals Available")}
                </div>

                {/* Subtitle */}
                <div
                  className="text-muted"
                >
                  {t(
                    "There are currently no hot deals in this province. Please check back later or explore other destinations.",
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default Hotdeal;
